import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

import StandardPageframe from '@/components/layouts/standard-pageframe.vue';
import ConversationSummary from '@/components/sms/conversation-summary.vue';
import ConversationSummaryOpenContactRequests from '@/components/sms/conversation-summary-open-contact-requests.vue';
import ConversationSummaries from '@/components/sms/conversation-summaries.vue';
import Avatar from '@/components/sms/avatar.vue';
import Conversation from '@/components/sms/conversation.vue';
import ConversationLine from '@/components/sms/conversation-line.vue';
import MessageContent from '@/components/sms/message-content.vue';
import MessageContentContactRequest from '@/components/sms/message-content-contact-request.vue';
import MessageContentVCard from '@/components/sms/message-content-vcard.vue';
import MessageContentImage from '@/components/sms/message-content-image.vue';
import MessageContentBulkMessageOptEvent from '@/components/sms/message-content-bulk-message-opt-event';
import CreateContactRequest from '@/views/contact-requests/create-contact-request-dialog.vue';
import ContactRequestCard from '@/views/contact-requests/contact-request-card.vue';
import MessageContextMenu from '@/components/sms/message-context-menu.vue';
import MessengerLayout from '@/components/layouts/messenger-layout.vue';
import StartNewChatDialog from '@/components/sms/start-new-chat-dialog.vue';
import EditLabelDialog from '@/components/sms/edit-label-dialog.vue';
import ReplyToCustomerDialog from '@/components/sms/reply-to-customer-dialog.vue';
import AdHocDNDDialog from '@/components/sms/ad-hoc-dnd-dialog.vue';
import InternalErrorDialog from '@/components/layouts/internal-error-dialog.vue';
import ServerUnavailableDialog from '@/components/layouts/server-unavailable-dialog.vue';
import SelectEmployeeDialog from '@/components/sms/select-employee-endpoint-dialog.vue';
import EditContactDialog from '@/components/sms/edit-contact-dialog.vue';
import ViewContact from '@/components/sms/view-contact.vue';
import ContactRequestSnackbar from '@/views/contact-requests/contact-request-snackbar.vue';
import ContactLine from '@/components/sms/contact-line.vue';
import IntervalDialog from '@/components/sms/interval-dialog.vue';
import DNDIntervals from '@/components/sms/dnd-intervals.vue';
import DatePickerDialog from '@/components/sms/date-picker-dialog.vue';
import CodeBlock from '@/components/sms/code-block.vue'
import ContactRequestInfoDialog from '@/views/contact-requests/contact-request-info-dialog.vue'
import CreateBulkOptOutDialog from '@/views/bulk/bulk-opt-out-dialog.vue';
import CreateBulkMessageDialog from '@/views/bulk/bulk-message-dialog.vue';
import BulkMessageOutcomeChangeDialog from '@/views/bulk/bulk-outcome-change-dialog.vue';
import BulkMessageOutcomeCreateDialog from '@/views/bulk/bulk-outcome-create-dialog.vue';
import BulkMessageRecipientEditDialog from '@/views/bulk/edit-bulk-message-recipient.vue';
import BulkMessageIntermediateRecipientEditDialog from '@/views/bulk/edit-bulk-intermediate-recipient.vue';
import BulkMessageRecipientPreviewDialog from '@/views/bulk/preview-bulk-recipients.vue';
import BulkMessageRecipientCustomMessageDialog from '@/views/bulk/custom-message-dialog.vue';
import BulkMessageRecipientPreviewMessageDialog from '@/views/bulk/preview-message-dialog.vue';
import BulkMessageSendProgressDialog from '@/views/bulk/dialog-bulk-message-progress.vue';
import BulkMessageSendTestDialog from '@/views/bulk/send-test-message-dialog.vue';

import EditText from '@/components/input/edit-text.vue';
import EditDate from '@/components/input/edit-date.vue';
import EditDateRange from '@/components/input/edit-date-range.vue';
import EditTextDialog from '@/components/input/edit-text-dialog.vue';
import EditChip from '@/components/input/edit-chip.vue';
import EditChipDialog from '@/components/input/edit-chip-dialog.vue';
import EditMenu from '@/components/input/edit-menu.vue';
import EditSelect from '@/components/input/edit-select.vue';
import EditSelectDialog from '@/components/input/edit-select-dialog.vue';


import StartOutboundCall from '@/components/sms/dialog-start-outbound-call.vue';


import SettingsOrganizationGeneral from '@/views/settings/organizations/settings-organization-general.vue';
import SettingsOrganizationTeamMembers from '@/views/settings/organizations/settings-organization-team-members.vue';
import SettingsOrganizationPhoneNumbers from '@/views/settings/organizations/settings-organization-phone-numbers.vue';
import SettingsOrganizationDomains from '@/views/settings/organizations/settings-organization-domains.vue';
import SettingsOrganizationGroups from '@/views/settings/organizations/settings-organization-groups.vue';
import SettingOrganizationInboxURLs from '@/views/settings/organizations/settings-organization-inbox-urls.vue';
import SettingsOrganizationHelpWidget from '@/views/settings/organizations/settings-organization-help-widget.vue';

import SettingsOrganizationDialogSelectTeamMember from '@/views/settings/organizations/dialog-select-employee.vue';
import SettingsOrganizationDialogSelectTeam from '@/views/settings/organizations/dialog-select-team.vue';
import SettingsOrganizationDialogAttachmentConfirmation from '@/views/settings/organizations/dialog-attachment-confirmation.vue';
import SettingsOrganizationDialogAddPhoneNumber from '@/views/settings/organizations/dialog-add-phone-number.vue';

import SettingsOrganizationDialogAddDomain from '@/views/settings/organizations/dialog-add-domain.vue';
import SettingsOrganizationDialogAddTeamMember from '@/views/settings/organizations/dialog-add-team-member.vue';
import SettingsOrganizationDialogSetPassword from '@/views/settings/organizations/dialog-set-password.vue';

import SettingsAccountGeneral from '@/views/settings/account/settings-account-general.vue';
import SettingsAccountNotifications from '@/views/settings/account/settings-account-notifications.vue'
import SettingsAccountOrganizationEndpoints from '@/views/settings/account/settings-account-organization-endpoints.vue';
import SettingsAccountContact from '@/views/settings/account/settings-account-contact.vue';
import SettingsAccountPassword from '@/views/settings/account/settings-account-password.vue';
import SettingsAccountPersonalDevices from '@/views/settings/account/settings-account-personal-devices.vue';
import SettingsAccountViewPersonalDevice from '@/views/settings/account/view-personal-device.vue';
import SettingsAccountEditPersonalDeviceDialog from '@/views/settings/account/edit-personal-device-dialog.vue';
import SettingsAccountPhoneCalls from '@/views/settings/account/settings-account-phone-calls.vue';
import SettingsAccountPhoneCallsForwardIncomingDialog from '@/views/settings/account/edit-forward-incoming-calls-dialog.vue';
import SettingsAccountEditTimezoneDialog from '@/views/settings/account/edit-timezone-dialog.vue';
import SettingsAccountArchivedDialog from '@/views/settings/account/edit-archived-settings-dialog.vue';

import SettingsEditSoundDialog from '@/views/settings/account/edit-sound-dialog.vue';
import EditDNDDialog from '@/views/settings/account/edit-dnd-dialog.vue';

import ContactRequestAssignDialog from '@/views/contact-requests/contact-request-assign-dialog.vue';
import ContactRequestForceAssignDialog from '@/views/contact-requests/contact-request-force-assign-dialog.vue';
import SavedMessageDialog from '@/views/saved-messages/edit-saved-message.vue';
import SearchSavedMessagesCtrl from '@/views/saved-messages/search-saved-messages-ctrl.vue';
import SearchSavedMessagesDialog from '@/views/saved-messages/search-saved-messages-dialog.vue';
import AutocompleteTeamMembers from '@/components/input/autocomplete-team-members.vue';
import AutocompleteOrganization from '@/components/input/autocomplete-organization.vue';
import AutocompletePhoneNumber from '@/components/input/autocomplete-phone-number.vue';
import AutocompleteCountryAndSubdivision from '@/components/input/autocomplete-country-and-subdivision.vue';
import GlobalSpinner from '@/components/global/spinner.vue';
import GlobalSnackbar from '@/components/global/snackbar.vue';
import GlobalAlert from '@/components/global/global-alert.vue';
import GlobalCallRingingDialog from '@/components/global/call-ringing-dialog.vue';

import SelectTimezone from '@/components/sms/select-timezone.vue';

Vue.component('m-pageframe', StandardPageframe);
Vue.component('m-conversation-summary', ConversationSummary);
Vue.component('m-conversation-summary-open-contact-requests', ConversationSummaryOpenContactRequests);
Vue.component('m-conversation-summaries', ConversationSummaries);
Vue.component('m-avatar',Avatar);
Vue.component('m-conversation',Conversation);
Vue.component('m-conversation-line',ConversationLine);
Vue.component('m-messenger-layout',MessengerLayout);
Vue.component('m-start-new-chat-dialog', StartNewChatDialog);
Vue.component('m-edit-label-dialog', EditLabelDialog);
Vue.component('m-reply-to-customer-dialog', ReplyToCustomerDialog);
Vue.component('m-message-content', MessageContent);
Vue.component('m-message-content-contact-request', MessageContentContactRequest);
Vue.component('m-message-content-vcard', MessageContentVCard);
Vue.component('m-message-content-image', MessageContentImage);
Vue.component('m-message-content-bulk-message-opt-event', MessageContentBulkMessageOptEvent);
Vue.component('m-message-context-menu', MessageContextMenu);
Vue.component('m-internal-error-dialog', InternalErrorDialog);
Vue.component('m-ad-hoc-dnd-dialog', AdHocDNDDialog);
Vue.component('m-server-unavailable-dialog', ServerUnavailableDialog);
Vue.component('m-select-employee-endpoint-dialog', SelectEmployeeDialog);
Vue.component('m-edit-contact-dialog', EditContactDialog);
Vue.component('m-view-contact',ViewContact);
Vue.component('m-contact-line', ContactLine);
Vue.component('m-code-block', CodeBlock);
Vue.component('m-edit-text',EditText);
Vue.component('m-edit-date', EditDate);
Vue.component('m-edit-date-range', EditDateRange);
Vue.component('m-edit-text-dialog', EditTextDialog);
Vue.component('m-edit-chip',EditChip);
Vue.component('m-edit-chip-dialog', EditChipDialog);
Vue.component('m-edit-menu', EditMenu);
Vue.component('m-edit-select', EditSelect);
Vue.component('m-edit-select-dialog', EditSelectDialog);
Vue.component('m-create-bulk-opt-out-dialog', CreateBulkOptOutDialog);
Vue.component('m-create-bulk-message-dialog', CreateBulkMessageDialog);
Vue.component('m-bulk-outcome-change-dialog', BulkMessageOutcomeChangeDialog);
Vue.component('m-bulk-outcome-create-dialog', BulkMessageOutcomeCreateDialog);
Vue.component('m-bulk-recipient-edit-dialog', BulkMessageRecipientEditDialog);
Vue.component('m-bulk-intermediate-recipient-edit-dialog', BulkMessageIntermediateRecipientEditDialog);
Vue.component('m-preview-bulk-recipients-dialog', BulkMessageRecipientPreviewDialog);
Vue.component('m-bulk-recipient-custom-message-dialog', BulkMessageRecipientCustomMessageDialog);
Vue.component('m-bulk-recipient-preview-message-dialog', BulkMessageRecipientPreviewMessageDialog);
Vue.component('m-bulk-message-progress-dialog', BulkMessageSendProgressDialog);
Vue.component('m-send-test-message-dialog', BulkMessageSendTestDialog);

Vue.component('m-settings-organization-general', SettingsOrganizationGeneral);
Vue.component('m-settings-organization-team-members', SettingsOrganizationTeamMembers);
Vue.component('m-settings-organization-phone-numbers', SettingsOrganizationPhoneNumbers);
Vue.component('m-settings-organization-domains', SettingsOrganizationDomains);
Vue.component('m-settings-organization-groups', SettingsOrganizationGroups);
Vue.component('m-settings-organization-inbox-urls', SettingOrganizationInboxURLs);
Vue.component('m-settings-organization-help-widget', SettingsOrganizationHelpWidget);


Vue.component('m-settings-organization-dialog-select-team-member', SettingsOrganizationDialogSelectTeamMember);
Vue.component('m-settings-organization-dialog-select-team', SettingsOrganizationDialogSelectTeam);
Vue.component('m-settings-organization-dialog-attachment-confirmation', SettingsOrganizationDialogAttachmentConfirmation);
Vue.component('m-settings-organization-add-phone-number', SettingsOrganizationDialogAddPhoneNumber);
Vue.component('m-settings-organization-add-domain', SettingsOrganizationDialogAddDomain);
Vue.component('m-settings-organization-add-team-member', SettingsOrganizationDialogAddTeamMember);
Vue.component('m-settings-organization-dialog-set-password',SettingsOrganizationDialogSetPassword);


Vue.component('m-settings-account-general',SettingsAccountGeneral);
Vue.component('m-settings-account-organization-endpoints',SettingsAccountOrganizationEndpoints);
Vue.component('m-settings-account-contact',SettingsAccountContact);
Vue.component('m-settings-account-password',SettingsAccountPassword);
Vue.component('m-settings-account-personal-devices',SettingsAccountPersonalDevices);
Vue.component('m-settings-account-notifications',SettingsAccountNotifications);


Vue.component('m-view-personal-device',SettingsAccountViewPersonalDevice);
Vue.component('m-edit-personal-device-dialog',SettingsAccountEditPersonalDeviceDialog);
Vue.component('m-settings-account-phone-calls',SettingsAccountPhoneCalls);
Vue.component('m-edit-forward-incoming-calls-dialog',SettingsAccountPhoneCallsForwardIncomingDialog);
Vue.component('m-edit-timezone-dialog',SettingsAccountEditTimezoneDialog);
Vue.component('m-archived-org-dialog', SettingsAccountArchivedDialog);

Vue.component('m-edit-sound-dialog',SettingsEditSoundDialog);
Vue.component('m-edit-dnd-dialog',EditDNDDialog);


Vue.component('m-start-outbound-call',StartOutboundCall);
Vue.component('m-select-timezone', SelectTimezone);

Vue.component('m-interval-dialog',IntervalDialog);
Vue.component('m-dnd-intervals', DNDIntervals);
Vue.component('m-date-picker-dialog', DatePickerDialog);

Vue.component('m-contact-request-snackbar', ContactRequestSnackbar);
Vue.component('m-contact-request-info-dialog', ContactRequestInfoDialog);

Vue.component('m-create-contact-request-dialog', CreateContactRequest);
Vue.component('m-contact-request-card', ContactRequestCard);
Vue.component('m-contact-request-force-assign-dialog',ContactRequestForceAssignDialog);
Vue.component('m-saved-message-dialog', SavedMessageDialog);
Vue.component('m-search-saved-messages-dialog', SearchSavedMessagesDialog);
Vue.component('m-search-saved-messages-ctrl', SearchSavedMessagesCtrl);
Vue.component('m-autocomplete-team-member', AutocompleteTeamMembers);
Vue.component('m-autocomplete-organization', AutocompleteOrganization);
Vue.component('m-autocomplete-phone-number', AutocompletePhoneNumber);
Vue.component('m-autocomplete-country-and-subdivision',AutocompleteCountryAndSubdivision);
Vue.component('m-global-spinner', GlobalSpinner);
Vue.component('m-global-snackbar', GlobalSnackbar);
Vue.component('m-global-alert', GlobalAlert);
Vue.component('m-global-call-ringing',GlobalCallRingingDialog);

import AdminAssignPhoneNumbersDialog from '@/views/admin/admin-assign-phone-numbers-dialog.vue';
Vue.component('m-admin-assign-phone-numbers-dialog', AdminAssignPhoneNumbersDialog);

import EditBlobs from '@/components/input/edit-blobs.vue';
Vue.component('m-edit-blobs', EditBlobs);

import EditBlobsDialog from '@/components/input/edit-blobs-dialog.vue';
Vue.component('m-edit-blobs-dialog', EditBlobsDialog);

import EulaViewDialog from '@/components/eula/eula-view-dialog.vue';
Vue.component('m-eula-view-dialog', EulaViewDialog);

import EulaSignDialog from '@/components/eula/eula-sign-dialog.vue';
Vue.component('m-eula-sign-dialog', EulaSignDialog);

import TestSnippetDialog from '@/views/test/dialogs/test-snippet-dialog.vue';
Vue.component('m-test-snippet-dialog', TestSnippetDialog);

import EmployeePaymentPermissionsDialog from '@/views/settings/organizations/settings-employee-payment-permissions-dialog.vue';
Vue.component('m-employee-payment-permissions-dialog', EmployeePaymentPermissionsDialog);

import EmployeeBulkMessagePermissionsDialog from '@/views/settings/organizations/settings-employee-bulk-message-permissions.vue';
Vue.component('m-employee-bulk-message-permissions', EmployeeBulkMessagePermissionsDialog);

import PaymentCard from '@/views/payments/payment-card.vue';
Vue.component('m-payment-card', PaymentCard);

import PaymentCardProperty from '@/views/payments/payment-card-property.vue';
Vue.component('m-card-property', PaymentCardProperty);

import PaymentChipState from '@/views/payments/payment-state-chip.vue';
Vue.component('m-payment-chip-state', PaymentChipState);



import GlobalConfirmWithResponse from '@/components/global/confirm-with-response.vue';
Vue.component('m-global-confirm-with-response', GlobalConfirmWithResponse);

import GlobalProcessDialog from '@/components/global/global-process-dialog.vue';
Vue.component('m-global-process-dialog', GlobalProcessDialog);

import GlobalRequestNumber from '@/components/global/request-number.vue';
Vue.component('m-global-request-number', GlobalRequestNumber);

import GlobalPrompt from '@/components/global/global-prompt.vue';
Vue.component('m-global-prompt', GlobalPrompt);

import MakePaymentAppBar from '@/views/payments/public/make-payment-app-bar.vue';
Vue.component('m-make-payment-app-bar', MakePaymentAppBar);

import MakePaymentInvoiceAndAmount from '@/views/payments/public/make-payment-invoice-and-amount.vue';
Vue.component('m-make-payment-invoice-and-amount', MakePaymentInvoiceAndAmount);

import MakePaymentPayByCard from '@/views/payments/public/make-payment-pay-by-card.vue';
Vue.component('m-make-payment-pay-by-card', MakePaymentPayByCard);

import MakePaymentPayByACH from '@/views/payments/public/make-payment-pay-by-ach.vue';
Vue.component('m-make-payment-pay-by-ach', MakePaymentPayByACH);

import MakePaymentThankYou from '@/views/payments/public/make-payment-thank-you.vue';
Vue.component('m-make-payment-thank-you', MakePaymentThankYou);

import SearchPaymentDescriptionsDialog from '@/views/payments/search-payment-descriptions-dialog.vue';
Vue.component('m-search-payment-descriptions-dialog', SearchPaymentDescriptionsDialog);

import MakePaymentAddress from '@/views/payments/public/make-payment-address.vue';
Vue.component('m-make-payment-address', MakePaymentAddress);

import SettingsOrganizationPayment from '@/views/settings/organizations/settings-organization-payment.vue';
Vue.component('m-settings-organization-payment', SettingsOrganizationPayment);

import SettingsOrganizationBannerBranding from '@/views/settings/organizations/settings-organization-banner-branding.vue';
Vue.component('m-settings-organization-banner-branding', SettingsOrganizationBannerBranding);

import CreatePaymentDialog from '@/views/payments/create-payment-dialog.vue';
Vue.component('m-payment-request-dialog', CreatePaymentDialog);

import MContactRequestCommerce7ManualEditDialog from '@/views/contact-requests/contact-request-commerce7-manual-edit.vue';
Vue.component('m-contact-request-commerce7-manual-edit-dialog', MContactRequestCommerce7ManualEditDialog);

import TextPasswordResetLinkDialog from '@/views/settings/account/text-password-reset-link-dialog.vue';
Vue.component('m-text-password-reset-link-dialog', TextPasswordResetLinkDialog);

import UsingIEDialog from '@/components/sms/using-ie-dialog.vue';
Vue.component('m-using-ie-dialog',UsingIEDialog);

import MessageDetailsDialog from '@/components/sms/message-details-dialog.vue';
Vue.component('m-message-details-dialog', MessageDetailsDialog);

import TestMessagesDialog from '@/components/sms/dialog-test-messages.vue';
Vue.component('m-test-messages-dialog', TestMessagesDialog);

import SettingOrganizationIntegrations from '@/views/settings/organizations/settings-organization-integrations.vue';
Vue.component('m-settings-organization-integrations', SettingOrganizationIntegrations);

import ADFSettingsDialog from '@/views/integrations/adf/adf-settings-dialog.vue';
Vue.component('m-adf-settings-dialog', ADFSettingsDialog);

import ADFSysAdminInfoDialog from '@/views/integrations/adf/adf-system-admin-info.vue';
Vue.component('m-adf-sys-admin-info-dialog', ADFSysAdminInfoDialog);

import CopyConversationDialog from '@/components/sms/copy-conversation-dialog.vue';
Vue.component('m-copy-conversation-dialog', CopyConversationDialog);

import ADFChooseMethod from '@/views/integrations/adf/adf-choose-method.vue';
Vue.component('m-adf-choose-method-dialog', ADFChooseMethod);

import MMobileAutocomplete from '@/components/input/mobile-autocomplete.vue';
Vue.component('m-mobile-autocomplete', MMobileAutocomplete);

import MMobileAutocompleteDialog from '@/components/input/mobile-autocomplete-dialog.vue';
Vue.component('m-mobile-autocomplete-dialog', MMobileAutocompleteDialog);

import HomeConversation from '@/components/sms/HomeConversation.vue';
Vue.component('m-home-conversation', HomeConversation);

import EditNoteDialog from '@/components/sms/edit-note-dialog.vue';
Vue.component('m-edit-note-dialog', EditNoteDialog);

import SettingsOrganizationLocations from '@/views/settings/organizations/settings-organization-locations.vue';
Vue.component('m-settings-organization-locations', SettingsOrganizationLocations);

import Address from '@/components/input/address.vue';
Vue.component('m-address', Address);

import AddressEditor from '@/components/input/address-editor.vue';
Vue.component('m-address-editor', AddressEditor);

import DailySchedule from '@/components/input/daily-schedule.vue';
Vue.component('m-daily-schedule', DailySchedule);

import DailyScheduleDialog from '@/components/input/daily-schedule-dialog.vue';
Vue.component('m-daily-schedule-dialog', DailyScheduleDialog);

import DailyScheduleIntervals from '@/components/input/daily-schedule-intervals.vue';
Vue.component('m-daily-schedule-intervals', DailyScheduleIntervals);

import DialogEditLocation from '@/views/settings/organizations/dialog-edit-location.vue';
Vue.component('m-edit-location-dialog', DialogEditLocation);

import DialogEditLocationCurbside from '@/views/settings/organizations/dialog-edit-location-curbside.vue';
Vue.component('m-edit-location-curbside-dialog', DialogEditLocationCurbside);

import NotificationPlan from '@/components/input/notification-plan.vue';
Vue.component('m-notification-plan', NotificationPlan);

import EditSelectLocation from '@/components/input/edit-select-location.vue';
Vue.component('m-edit-select-location', EditSelectLocation);


import DialogCreateContact from '@/views/contacts/create-contact-dialog.vue';
Vue.component('m-create-contact-dialog',DialogCreateContact);

import DialogSearchPreviouslyUploadedAttachments from '@/components/input/search-previously-uploaded-attachments.vue';
Vue.component('m-search-previously-uploaded-attachments', DialogSearchPreviouslyUploadedAttachments)


import EditSelectEmployee from '@/components/input/edit-select-employee.vue';
Vue.component('m-edit-select-employee', EditSelectEmployee);

import EditSelectTeamNumber from '@/components/input/edit-select-team-number.vue';
Vue.component('m-edit-select-team-number', EditSelectTeamNumber);



import EditTextArea from '@/components/input/edit-textarea.vue';
Vue.component('m-edit-textarea', EditTextArea);

import EditTextAreaDialog from '@/components/input/edit-textarea-dialog.vue';
Vue.component('m-edit-textarea-dialog', EditTextAreaDialog);

import DialogAdminLinkToConversation from '@/views/admin/dialog-admin-link-to-conversation.vue';
Vue.component('m-dialog-admin-link-to-conversation', DialogAdminLinkToConversation);

import ConversationIsTyping from '@/components/sms/conversation-is-typing.vue';
Vue.component('m-conversation-is-typing', ConversationIsTyping);

import ContactRequestIsTyping from '@/components/sms/contact-request-is-typing.vue';
Vue.component('m-contact-request-is-typing', ContactRequestIsTyping);

import OtherConversations from '@/components/sms/other-conversations.vue';
Vue.component('m-other-conversations', OtherConversations);

import DialogOtherConversationsMore from '@/components/sms/dialog-other-conversations-more.vue';
Vue.component('m-other-conversations-more-dialog', DialogOtherConversationsMore);

import DialogAdminEditMessage from '@/components/sms/dialog-admin-edit-message.vue';
Vue.component('m-dialog-admin-edit-message', DialogAdminEditMessage);

import PlatypusTourCard from '@/views/public/platypus/tour-card.vue';
Vue.component('m-platypus-tour-card', PlatypusTourCard);

import TastingCard from '@/views/public/tasting/tasting-card.vue';
Vue.component('m-tasting-card', TastingCard);

import ComposeMessageDialog from '@/components/input/compose-message-dialog.vue';
Vue.component('m-compose-message-dialog', ComposeMessageDialog);

import AdminActivityInDNDDetails from '@/views/admin/admin-details-activity-in-dnd.vue';
Vue.component('m-admin-details-activity-in-dnd', AdminActivityInDNDDetails);

import NamedPair from '@/components/global/named-pair.vue';
Vue.component('m-named-pair', NamedPair);

import InboxEmailLogEntryCard from '@/views/settings/organizations/inbox-email-log-card.vue';
Vue.component('m-inbox-email-log-entry-card', InboxEmailLogEntryCard);


import DialogCRMSettings from '@/views/settings/organizations/settings-dialog-integration-crm.vue';
Vue.component('m-dialog-crm-settings', DialogCRMSettings);

import PhoneNumberValidationData from '@/components/sms/phone-number-validation-data.vue';
Vue.component('m-phone-number-validation-data', PhoneNumberValidationData);

import PhoneNumberValidationDetailsDialog from '@/components/sms/phone-number-validation-details-dialog.vue';
Vue.component('m-phone-number-validation-details-dialog', PhoneNumberValidationDetailsDialog);

import WSUploadAvatarConfirmDialog from '@/views/settings/organizations/upload-avatar-confirm-dialog.vue';
Vue.component('m-widget-settings-upload-avatar-confirm-dialog', WSUploadAvatarConfirmDialog);

import EditWidgetSettingsColorLine from '@/views/settings/organizations/edit-widget-settings-color-line.vue';
Vue.component('m-edit-color-line', EditWidgetSettingsColorLine);

import TestWidgetControl from '@/views/settings/organizations/test-widget-control.vue';
Vue.component('m-test-widget', TestWidgetControl);

import PhoneValidationChip from '@/components/sms/phone-validation-chip.vue';
Vue.component('m-phone-validation-chip', PhoneValidationChip);

import EditSelectRateCard from '@/components/input/edit-select-rate-card.vue';
Vue.component('m-edit-select-rate-card', EditSelectRateCard);

import RestrictedField from '@/components/global/m-restricted-field.vue';
Vue.component('m-restricted-field', RestrictedField);

import RestrictedButton from '@/components/global/m-restricted-button.vue';
Vue.component('m-restricted-button', RestrictedButton);

import RestrictedMenuListItem from '@/components/global/m-restricted-menu-list-item.vue';
Vue.component('m-restricted-menu-list-item', RestrictedMenuListItem);

import RestrictedTableHeaderCell from '@/components/global/m-restricted-table-header-cell.vue';
Vue.component('m-restricted-table-header-cell', RestrictedTableHeaderCell);

import CustomizeRateCardValueDialog from '@/views/settings/organizations/settings-organization-rate-card-custom-value.vue';
Vue.component('m-customize-rate-card-value-dialog', CustomizeRateCardValueDialog);

import IntuitCustomerSearchDialog from '@/views/integrations/intuit/intuit-search-customer-dialog.vue';
Vue.component('m-intuit-search-customer-dialog', IntuitCustomerSearchDialog);

import InvoicePeriodSelector from '@/views/billing/invoice-period-selector.vue';
Vue.component('m-invoice-period-selector', InvoicePeriodSelector);

import DialogFollowConversation from '@/components/sms/dialog-follow-conversation.vue';
Vue.component('m-dialog-follow-conversation', DialogFollowConversation);

import DialogEmployeeFollowingAddEndpoint from '@/views/settings/account/employee-following-add-endpoint-dialog.vue';
Vue.component('m-dialog-employee-following-add-endpoint', DialogEmployeeFollowingAddEndpoint);

import AutocompleteConversationLabels from '@/components/input/autocomplete-conversation.vue';
Vue.component('m-autocomplete-conversation', AutocompleteConversationLabels);

import DialogAddFollowConversation from '@/views/settings/account/employee-following-add-conversation-dialog.vue';
Vue.component('m-dialog-add-follow-conversation', DialogAddFollowConversation);

import NeedsAttentionCounts from '@/components/sms/needs-attention-counts.vue';
Vue.component('m-needs-attention-counts', NeedsAttentionCounts);

import EditDurationDialog from '@/components/input/edit-duration-dialog.vue';
Vue.component('m-edit-duration-dialog', EditDurationDialog);

import EditMessagePatterns from '@/components/input/edit-message-patterns.vue';
Vue.component('m-edit-message-patterns', EditMessagePatterns);

import EditMessagePatternsVariableDialog from '@/components/input/edit-message-patterns-variable-dialog.vue';
Vue.component('m-edit-message-patterns-variable-dialog', EditMessagePatternsVariableDialog);

import PopulateMessagePatterns from '@/components/input/populate-message-patterns.vue';
Vue.component('m-populate-message-patterns', PopulateMessagePatterns);

import KeywordEditDialog from '@/views/settings/organizations/keyword_auto_responses/keyword-edit-dialog.vue';
Vue.component('m-keyword-edit-dialog', KeywordEditDialog);

import DialogAdminSelectInboxToForwardTo from '@/views/settings/organizations/inboxes/dialog-admin-select-inbox-to-forward-to.vue';
Vue.component('m-dialog-admin-select-inbox-to-forward-to', DialogAdminSelectInboxToForwardTo);

import DialogCopyInboxValues from '@/views/settings/organizations/inboxes/dialog-copy-inbox-values.vue';
Vue.component('m-copy-inbox-value-dialog', DialogCopyInboxValues);

import SettingsOrganizationDialogAddInbox from '@/views/settings/organizations/inboxes/dialog-create-inbox.vue';
Vue.component('m-dialog-create-inbox', SettingsOrganizationDialogAddInbox);

import DialogForwardContactRequest from '@/components/sms/dialog-forward-contact-request.vue';
Vue.component('m-dialog-forward-contact-request', DialogForwardContactRequest);

import EditInstant from '@/components/input/m-edit-instant.vue';
Vue.component('m-edit-instant', EditInstant);

import EditInstantDialog from '@/components/input/m-edit-instant-dialog.vue';
Vue.component('m-edit-instant-dialog', EditInstantDialog);

import Showdown from '@/components/input/m-showdown.vue';
Vue.component('m-showdown', Showdown);

import IncidentDetail from '@/views/incidents/incident-detail-dialog.vue';
Vue.component('m-incident-detail-dialog', IncidentDetail);

import IncidentBanner from '@/views/incidents/incident-banner.vue';
Vue.component('m-incident-banner', IncidentBanner);

import EditComboBoxDialog from '@/components/global/combobox-prompt.vue';
Vue.component('m-global-combo-box-prompt', EditComboBoxDialog);

import MGlobalPromptTime from '@/components/global/global-prompt-time.vue';
Vue.component('m-global-prompt-time', MGlobalPromptTime);

import EditSelectBoxDialog from '@/components/global/select-prompt.vue';
Vue.component('m-global-select-prompt', EditSelectBoxDialog);

import ConsentRegisterAPIInstructionsDialog from '@/views/bulk/consent-register-api-instructions-dialog.vue';
Vue.component('m-consent-register-api-instructions-dialog', ConsentRegisterAPIInstructionsDialog);

import GlobalCodeDialog from '@/components/global/global-code-dialog.vue';
Vue.component('m-global-code-dialog', GlobalCodeDialog);

import GlobalSignInAs from '@/components/global/global-sign-in-as.vue';
Vue.component('m-global-sign-in-as', GlobalSignInAs);

import GlobalNewVersionAlert from '@/components/global/alert-new-version.vue';
Vue.component('m-alert-new-version', GlobalNewVersionAlert);


import DialogAddMultipleListMembersText from '@/views/lists/dialog-add-multiple-list-members-text.vue';
Vue.component('m-dialog-add-multiple-list-members-text', DialogAddMultipleListMembersText);

import DialogGlobalWarn from '@/components/global/global-warn.vue';
Vue.component('m-global-warn', DialogGlobalWarn);

import DialogGlobalTechnicalDetails from '@/components/global/global-technical-details.vue';
Vue.component('m-global-technical-details', DialogGlobalTechnicalDetails);

import GlobalConfirm from '@/components/global/confirm.vue';
Vue.component('m-global-confirm', GlobalConfirm);

import DialogQuickBulkMessage from '@/components/sms/dialog-quick-bulk-message.vue';
Vue.component('m-dialog-quick-bulk-message', DialogQuickBulkMessage);

import SettingsOrganizationUtilization from '@/views/settings/organizations/settings-organization-utilization.vue';
Vue.component('m-settings-organization-utilization', SettingsOrganizationUtilization);

import AdminOrganizationSignInAsDialog from '@/views/admin/admin-organization-sign-in-as-dialog.vue';
Vue.component('m-admin-org-sign-in-as-dialog', AdminOrganizationSignInAsDialog);

import SelectCurrency from '@/components/input/m-select-currency.vue';
Vue.component('m-select-currency', SelectCurrency);

import ExcelImportFormatErrorDialog from '@/views/bulk/excel-format-error-dialog.vue';
Vue.component('m-excel-import-format-error', ExcelImportFormatErrorDialog);

import DialogChangeSpamState from '@/views/settings/organizations/dialog-change-spam-state.vue';
Vue.component('m-dialog-change-spam-state', DialogChangeSpamState);

import DialogChangeSpamForEndpoint from '@/views/settings/organizations/settings-organization-spam-dialog.vue';
Vue.component('m-dialog-change-spam-state-endpoint', DialogChangeSpamForEndpoint);

import DialogCRMSelectCustomer from '@/views/integrations/crm/integration-crm-select-customer-dialog.vue';
Vue.component('m-integration-crm-select-customer-dialog', DialogCRMSelectCustomer);

import EditSelectEnum from '@/components/input/edit-select-enum.vue';
Vue.component('m-edit-select-enum', EditSelectEnum);

import EditSelectEnumDialog from '@/components/input/edit-select-enum-dialog.vue';
Vue.component('m-edit-select-enum-dialog', EditSelectEnumDialog);

import SelectConsentAgreement from '@/components/input/select-consent-agreement.vue';
Vue.component('m-select-consent-agreement', SelectConsentAgreement);

import AddOneInServiceNumber from '@/views/admin/admin-add-one-inservice-number.vue';
Vue.component('m-admin-add-one-in-service-number', AddOneInServiceNumber);

import DisplayText from '@/components/input/display-text.vue';
Vue.component('m-display-text', DisplayText);

import TechnicalDetailsDialog from '@/views/endpoint-validation/technical-details-dialog.vue';
Vue.component('m-technical-details-dialog', TechnicalDetailsDialog);

import IntroductionDialog from '@/components/sms/introduction-dialog.vue';
Vue.component('m-introduction-dialog', IntroductionDialog);

import SettingsAccountAvailableHours from '@/views/settings/account/settings-account-available-hours.vue';
Vue.component('m-settings-account-available-hours', SettingsAccountAvailableHours);


import SettingsOrganizationBrandedLinkShortenerAddHostDialog from '@/views/settings/organizations/settings-organization-branded-link-shortener-add-host-dialog.vue';
Vue.component('m-settings-organization-branded-link-shortener-add-host-dialog', SettingsOrganizationBrandedLinkShortenerAddHostDialog);

import AutoMessageMessageCtrls from '@/views/auto-messages/auto-message-message-ctrls.vue';
Vue.component('m-auto-message-message-ctrls', AutoMessageMessageCtrls);

import AutoMessageConditionEditDialog from '@/views/auto-messages/auto-message-condition-dialog.vue';
Vue.component('m-auto-message-condition-edit-dialog', AutoMessageConditionEditDialog);

import DialogSignInAs from '@/components/layouts/dialog-sign-in-as.vue';
Vue.component('m-dialog-sign-in-as', DialogSignInAs);

import MakePaymentContent from '@/views/payments/public/make-payment-content.vue';
Vue.component('m-make-payment-content', MakePaymentContent);

import BulkMessageSearchImportsDialog from '@/views/bulk/view-excel-imports.vue';
Vue.component('m-bulk-message-search-imports-dialog', BulkMessageSearchImportsDialog);

import AutoMessageAddCRMEmailDialog from '@/views/auto-messages/auto-message-add-crm-email-campaign.vue';
Vue.component('m-auto-message-add-crm-email-dailog', AutoMessageAddCRMEmailDialog);

import BulkMessageAttachmentWarningDialog from '@/views/bulk/bulk-message-attachment-warning-dialog.vue';
Vue.component('m-bulk-message-attachment-warning-dialog', BulkMessageAttachmentWarningDialog);

import GlobalDialogEmojiSearch from '@/components/global/emoji-search-dialog.vue';
Vue.component('m-global-emoji-search-dialog', GlobalDialogEmojiSearch);

import EditVCard from '@/components/input/m-edit-vcard.vue';
Vue.component('m-edit-vcard', EditVCard);

import EditVCardDialog from '@/components/input/edit-vcard-dialog.vue';
Vue.component('m-edit-vcard-dialog', EditVCardDialog);

import ChooseVCardDialog from '@/components/sms/choose-vcard-dialog.vue';
Vue.component('m-choose-vcard-dialog', ChooseVCardDialog);

import SelectVCard from '@/components/input/edit-select-vcard.vue';
Vue.component('m-select-vcard', SelectVCard);

import IconBar from '@/components/input/m-icon-bar.vue';
Vue.component('m-icon-bar', IconBar);

import MTextField from '@/components/input/m-text-field.vue';
Vue.component('m-text-field', MTextField);

import MRCCRMNotes from '@/components/rc_crm/rc-crm-notes.vue';
Vue.component('m-rc-crm-notes', MRCCRMNotes);

import MRCCRMNotesDialog from '@/components/rc_crm/rc-crm-notes-dialog.vue';
Vue.component('m-rc-crm-notes-dialog', MRCCRMNotesDialog);

import MSettingsTOTPDialog from '@/views/settings/account/setup-totp-dialog.vue';
Vue.component('m-setup-totp-dialog', MSettingsTOTPDialog);

import MTagColorPickerDialog from '@/views/settings/organizations/tags/tag-color-dialog.vue';
Vue.component('m-tag-color-picker-dialog', MTagColorPickerDialog);

import MGlobalChangeTags from '@/components/global/global-change-tags.vue';
Vue.component('m-global-change-tags', MGlobalChangeTags);

import MTagDisplay from '@/views/settings/organizations/tags/rc-tag-display.vue';
Vue.component('m-rc-tag-display', MTagDisplay);

import MEditTags from '@/components/input/edit-tags.vue';
Vue.component('m-edit-tags', MEditTags);

import MEditTagFilter from '@/components/input/edit-tag-filter.vue';
Vue.component('m-edit-tag-filter', MEditTagFilter);

import MEditTagFilterDialog from '@/components/input/edit-tag-filter-dialog.vue';
Vue.component('m-edit-tag-filter-dialog', MEditTagFilterDialog);

import MEditRCRMOrganizationDialog from '@/components/rc_crm/rc-crm-organization-edit-dialog.vue'
Vue.component('m-edit-rc-crm-organization-dialog', MEditRCRMOrganizationDialog);

import MCRMOrganizationMetaData from '@/components/rc_crm/rc-crm-organization-meta-data.vue'
Vue.component('m-rc-crm-organization-meta-data', MCRMOrganizationMetaData);

import MRCCRMNoteCard from '@/components/rc_crm/rc-crm-note-card.vue';
Vue.component('m-rc-crm-note', MRCCRMNoteCard);

import MGlobalExcelExportDialog from '@/components/global/global-excel-export-dialog.vue';
Vue.component('m-global-excel-export-dialog', MGlobalExcelExportDialog);


import MRCCRMEditNoteDialog from '@/components/rc_crm/rc-crm-edit-note-dialog.vue';
Vue.component('m-rc-crm-edit-note-dialog', MRCCRMEditNoteDialog);

import MRCCRMViewEditHistoryDialog from '@/components/rc_crm/rc-crm-note-edit-history-dialog.vue';
Vue.component('m-rc-crm-view-edit-history-dialog', MRCCRMViewEditHistoryDialog);

import MBooleanSearchFilter from '@/components/input/boolean-search-filter.vue';
Vue.component('m-boolean-search-filter', MBooleanSearchFilter);

import MEditMessagePatternsCompact from '@/components/input/edit-message-patterns-compact.vue';
Vue.component('m-edit-message-patterns-compact', MEditMessagePatternsCompact);

import MAdminOrganizationAutoActionDialog from '@/views/admin/admin-organization-auto-action-dialog.vue';
Vue.component('m-admin-organization-auto-action-dialog', MAdminOrganizationAutoActionDialog);

import MAutoMessageTemplateSearchTable from '@/views/auto-messages/auto-message-template-search-table.vue';
Vue.component('m-auto-message-template-search-table', MAutoMessageTemplateSearchTable);

import MNewDripMessageDialog from '@/views/auto-messages/new-drip-message-dialog.vue';
Vue.component('m-new-drip-message-dialog', MNewDripMessageDialog);

import MWelcomeSetupTeam from '@/views/welcome/welcome-setup-team.vue';
Vue.component('m-welcome-setup-team', MWelcomeSetupTeam);

import MWelcomeIntegrations from '@/views/welcome/welcome-integrations.vue';
Vue.component('m-welcome-integrations', MWelcomeIntegrations);

import MWelcomeNumberingPlan from '@/views/welcome/welcome-numbering-plan.vue';
Vue.component('m-welcome-numbering-plan', MWelcomeNumberingPlan);

import MWelcomeScreenSettingsDialog from '@/views/welcome/welcome-screen-settings-dialog.vue';
Vue.component('m-welcome-screen-settings-dialog', MWelcomeScreenSettingsDialog);


import MOrganizationEventCard from '@/views/integrations/calendar/organization-event-card.vue';
Vue.component('m-organization-event-card', MOrganizationEventCard);

import MMediaAssetSearch from '@/views/media-assets/media-asset-search.vue';
Vue.component('m-media-asset-search', MMediaAssetSearch);

import MTodoBar from '@/components/input/m-todo-bar.vue';
Vue.component('m-todo-bar', MTodoBar);


import MGlobals from '@/components/global/all-global-controls.vue';
Vue.component('m-globals', MGlobals);

import MRequestSupport from '@/components/global/global-request-support.vue';
Vue.component('m-request-support', MRequestSupport);

import MWelcomeExpansionPanelHeader from '@/views/welcome/welcome-expansion-panel-header.vue';
Vue.component('m-welcome-expansion-panel-header', MWelcomeExpansionPanelHeader);

import MWelcomeSysAdminsOnly from '@/views/welcome/welcome-sys-admins-only.vue';
Vue.component('m-welcome-sys-admins-only', MWelcomeSysAdminsOnly);

import MSignaturePacketDocuments from '@/components/eula/signature-packet-documents.vue';
Vue.component('m-signature-packet-documents', MSignaturePacketDocuments);

import MSignPacket from '@/components/eula/sign-packet.vue';
Vue.component('m-sign-packet', MSignPacket);

import MWelcomeSignSubscriptionAgreement from '@/views/welcome/welcome-sign-subscription-agreement.vue';
Vue.component('m-welcome-sign-subscription-agreement', MWelcomeSignSubscriptionAgreement);

import MRedChirpPaymentMethod from '@/views/settings/organizations/redchirp-payment-method.vue';
Vue.component('m-redchirp-payment-method', MRedChirpPaymentMethod);

import MRedChirpPaymentMethods from '@/views/settings/organizations/redchirp-payment-methods.vue';
Vue.component('m-redchirp-payment-methods', MRedChirpPaymentMethods);

import MWelcomeTCR from '@/views/welcome/welcome-tcr.vue';
Vue.component('m-welcome-tcr', MWelcomeTCR);

import MEditEmails from '@/components/input/edit-emails.vue';
Vue.component('m-edit-emails', MEditEmails);

import MRedChirpPaymentOrgControlledBillingSettings from '@/views/settings/organizations/redchirp-payment-org-controlled-billing-settings.vue';
Vue.component('m-redchirp-payment-org-controlled-billing-settings', MRedChirpPaymentOrgControlledBillingSettings);

import MLegalCheckBoxAgreement from '@/components/legal/legal-checkbox-agreement.vue';
Vue.component('m-legal-checkbox-agreement', MLegalCheckBoxAgreement);

import MCustomFormFieldEditor from '@/views/settings/forms/custom-form-field-editor.vue';
Vue.component('m-custom-form-field-editor', MCustomFormFieldEditor);

import MFormEditor from '@/views/settings/forms/edit-form-control.vue';
Vue.component('m-form-editor', MFormEditor);

import MCustomFormControl from '@/views/settings/forms/custom-form-control.vue';
Vue.component('m-custom-form-control', MCustomFormControl);

import MCustomFormField from '@/views/settings/forms/custom-form-field.vue';
Vue.component('m-custom-form-field', MCustomFormField);

import MQRCodeDialog from '@/components/input/qr-code-dialog.vue';
Vue.component('m-qr-code-dialog', MQRCodeDialog);

import AdminMultiDemoResetDialog from '@/views/admin/admin-multidemo-reset-dialog.vue';
Vue.component('m-admin-mutlidemo-reset-dialog', AdminMultiDemoResetDialog);

import MEditSelectOrganizationOwnedEndpoint from '@/components/input/m-edit-select-organization-owned-endpoint.vue';
Vue.component('m-edit-select-organization-owned-endpoint', MEditSelectOrganizationOwnedEndpoint);

import MSelectTCRCampaign from '@/views/settings/organizations/tcr/dialog-select-tcr-campaign.vue';
Vue.component('m-dialog-select-tcr-campaign', MSelectTCRCampaign);

import MAdminAlertDetailsDialog from '@/views/admin/admin-alert-details-dialog.vue';
Vue.component('m-admin-alert-details-dialog', MAdminAlertDetailsDialog);

import MAdminBillingSetCompleteDialog from '@/views/billing/admin-billing-set-complete-dialog.vue';
Vue.component('m-admin-billing-set-complete-dialog', MAdminBillingSetCompleteDialog);

import MGlobalCopyDialog from '@/components/global/global-copy-dialog.vue';
Vue.component('m-global-copy-dialog', MGlobalCopyDialog);

import MAdminBillingBatchOperationDialog from '@/views/billing/admin-billing-batch-operation-dialog.vue';
Vue.component('m-admin-billing-batch-operation-dialog', MAdminBillingBatchOperationDialog);

import MWelcomeGeneral from '@/views/welcome/welcome-general.vue';
Vue.component('m-welcome-general', MWelcomeGeneral);

import MWelcomeWebsite from '@/views/welcome/welcome-website.vue';
Vue.component('m-welcome-website', MWelcomeWebsite);

import MSettingOrganizationScheduleCell from '@/views/settings/organizations/settings-organization-schedule-cell.vue';
Vue.component('m-settings-organization-schedule-cell', MSettingOrganizationScheduleCell);

import MGlobalPick from '@/components/global/global-pick.vue';
Vue.component('m-global-pick', MGlobalPick);

import MLogViewDialog from '@/components/global/log-view-dialog.vue';
Vue.component('m-log-view-dialog', MLogViewDialog);

import MAIContactRequestSuggestedReplyDialog from '@/views/contact-requests/ai-contact-request-suggested-reply-dialog.vue';
Vue.component('m-ai-contact-request-suggested-reply-dialog', MAIContactRequestSuggestedReplyDialog);

import MEditLink from '@/views/settings/organizations/links/edit-link.vue';
Vue.component('m-edit-link', MEditLink);

import MEditCalendarEventDialog from '@/views/integrations/calendar/edit-calendar-event.vue';
Vue.component('m-edit-calendar-event-dialog', MEditCalendarEventDialog);

import MAutoComplete from '@/components/input/m-autocomplete.vue';
Vue.component('m-autocomplete', MAutoComplete);

import MEditMonetaryAmount from '@/components/input/edit-monetary-amount.vue';
Vue.component('m-edit-monetary-amount', MEditMonetaryAmount);

import MEditEmployeeNotificationEmailDialog from '@/views/settings/account/edit-employee-notification-email-dialog.vue';
Vue.component('m-edit-employee-notification-email-dialog', MEditEmployeeNotificationEmailDialog);

import MEditEmployeeNotificationPushoverDialog from '@/views/settings/account/edit-employee-notification-pushover-dialog.vue';
Vue.component('m-edit-employee-notification-pushover-dialog', MEditEmployeeNotificationPushoverDialog);

import MMediaAssetCard from '@/views/media-assets/media-asset-card.vue';
Vue.component('m-media-asset-card', MMediaAssetCard);

import MBlobCard from '@/views/media-assets/blob-card.vue';
Vue.component('m-blob-card', MBlobCard);

import MImageSizeControl from '@/views/media-assets/image-size-control.vue';
Vue.component('m-image-size-control', MImageSizeControl);

import MImageSelector from '@/components/input/image-selector.vue';
Vue.component('m-image-selector', MImageSelector);

import MMediaAssetPickerDialog from '@/views/media-assets/media-asset-pick-dialog.vue';
Vue.component('m-media-asset-picker-dialog', MMediaAssetPickerDialog);

import MAdminMultiOrgEmployeeAddDialog from '@/views/admin/admin-multi-org-employee-add-dialog.vue';
Vue.component('m-multi-org-employee-add-dialog', MAdminMultiOrgEmployeeAddDialog);

import MSelectEmployeeEndpoint from '@/components/sms/select-employee-endpoint.vue';
Vue.component('m-select-employee-endpoint', MSelectEmployeeEndpoint);

import MListButtons from '@/components/input/m-list-buttons.vue';
Vue.component('m-list-buttons', MListButtons);

import MIntegrationFeaturesDialog from '@/views/integrations/integration-features-dialog.vue';
Vue.component('m-integration-features-dialog', MIntegrationFeaturesDialog);

import MNRRSettingsDialog from '@/views/billing/admin-nrr-settings-dialog.vue';
Vue.component('m-nrr-settings-dialog', MNRRSettingsDialog);

import MEditSelectObjects from '@/components/input/edit-select-objects.vue';
Vue.component('m-edit-select-objects', MEditSelectObjects);

import MSelectObjectDialog from '@/components/input/m-select-object-dialog.vue';
Vue.component('m-select-object-dialog', MSelectObjectDialog);

import MAdminBillingCreditEditDialog from '@/views/billing/admin-billing-credit-edit-dialog.vue';
Vue.component('m-admin-billing-credit-edit-dialog', MAdminBillingCreditEditDialog);

import MWelcomeOptionalSection from '@/views/welcome/welcome-optional-section.vue';
Vue.component('m-welcome-optional-section', MWelcomeOptionalSection);

import MEditWallTime from '@/components/input/m-edit-wall-time.vue';
Vue.component('m-edit-wall-time', MEditWallTime);

import MEditWallTimeDialog from '@/components/input/m-edit-wall-time-dialog.vue';
Vue.component('m-edit-wall-time-dialog', MEditWallTimeDialog);

import MEditBulkMessageFilters from '@/views/bulk/edit-bulk-message-filters.vue';
Vue.component('m-edit-bulk-message-filters', MEditBulkMessageFilters);

import MReportProgressDialog from '@/views/admin/admin-report-dialog.vue';
Vue.component('m-report-progress-dialog', MReportProgressDialog);

import MEditTimePeriod from '@/components/input/m-edit-time-period.vue';
Vue.component('m-edit-time-period', MEditTimePeriod);

import MChartHistogram from '@/components/analytics/m-chart-histogram.vue';
Vue.component('m-chart-histogram', MChartHistogram);

import MOrderAttributionSettingsDialog from '@/components/analytics/m-order-attribution-settings-dialog.vue';
Vue.component('m-order-attribution-settings-dialog', MOrderAttributionSettingsDialog);

import MChartDonut from '@/components/analytics/m-chart-donut.vue';
Vue.component('m-chart-donut', MChartDonut)

import MChartLine from '@/components/analytics/m-chart-line.vue';
Vue.component('m-chart-line', MChartLine)

import MChartLeaderboard from '@/components/analytics/m-chart-leaderboard.vue';
Vue.component('m-chart-leaderboard', MChartLeaderboard)

import MScheduleMessageDialog from '@/components/input/schedule-message-dialog.vue';
Vue.component('m-schedule-message-dialog', MScheduleMessageDialog);

import MSignInTotp from '@/views/sign-in-totp.vue';
Vue.component('m-sign-in-totp', MSignInTotp);

import MHelpBanner from '@/components/input/m-help-banner.vue';
Vue.component('m-help-banner', MHelpBanner);

import MMainNavigation from '@/components/layouts/m-main-navigation.vue';
Vue.component('m-main-navigation', MMainNavigation);

import MProvisionGeneral from '@/views/provision/provision-general.vue';
Vue.component('m-provision-general', MProvisionGeneral);

import MProvisionRateCard from '@/views/provision/provision-rate-card.vue';
Vue.component('m-provision-rate-card', MProvisionRateCard);

import MSettingsOrganizationRateCardCtrl from '@/views/settings/organizations/settings-organization-rate-card-ctrl.vue';
Vue.component('m-settings-organization-rate-card-ctrl', MSettingsOrganizationRateCardCtrl);

import MProvisionTeam from '@/views/provision/provision-team.vue';
Vue.component('m-provision-team', MProvisionTeam);

import MProvisionNote from '@/views/provision/provision-note.vue';
Vue.component('m-provision-note', MProvisionNote);

import MProvisionFeatures from '@/views/provision/provision-features.vue';
Vue.component('m-provision-features', MProvisionFeatures);

import MProvisionFooter from '@/views/provision/provision-footer.vue';
Vue.component('m-provision-footer', MProvisionFooter);

import MProvisionPhoneNumberPlan from '@/views/provision/provision-phone-number-plan.vue';
Vue.component('m-provision-phone-number-plan', MProvisionPhoneNumberPlan);

import MProvisionTCR from '@/views/provision/provision-tcr.vue';
Vue.component('m-provision-tcr', MProvisionTCR);

import MSettingsOrganizationAPIKeyEditDialog from '@/views/settings/organizations/settings-organization-api-key-edit-dialog.vue';
Vue.component('m-settings-organization-api-key-edit-dialog', MSettingsOrganizationAPIKeyEditDialog);

import BetaAlert from '@/components/global/alert-beta-feature.vue';
Vue.component('m-beta-alert', BetaAlert);

import BulkMessageTemplateCreateBulkMessageDialog from '@/views/bulk/templates/bulk-message-template-create-bulk-message-dialog.vue';
Vue.component('m-bulk-message-template-create-bulk-message-dialog', BulkMessageTemplateCreateBulkMessageDialog);

import BulkMessageTemplateViewAllDialog from '@/views/bulk/templates/bulk-message-template-view-all-dialog.vue';
Vue.component('m-bulk-message-template-view-all-dialog', BulkMessageTemplateViewAllDialog);

import EditBulkMessageTemplateDialog from '@/views/bulk/edit-bulk-message-template-dialog.vue';
Vue.component('m-edit-bulk-message-template-dialog', EditBulkMessageTemplateDialog);

import BulkMessageTemplateTypeCards from '@/views/bulk/templates/bulk-message-template-type-cards.vue';
Vue.component('m-bulk-message-template-type-cards', BulkMessageTemplateTypeCards);

import BulkMessageTemplateViewAllCards from '@/views/bulk/templates/bulk-message-template-view-all-cards.vue';
Vue.component('m-bulk-message-template-view-all-cards', BulkMessageTemplateViewAllCards);

import BulkMessageTemplatePickDialog from '@/views/bulk/templates/bulk-message-template-pick-dialog.vue';
Vue.component('m-bulk-message-template-pick-dialog', BulkMessageTemplatePickDialog);

import MEditCustomConsentAgreement from '@/views/settings/consent-agreements/edit-custom-consent-agreement.vue';
Vue.component('m-edit-custom-consent-agreement-dialog', MEditCustomConsentAgreement);

import MIntegrationsThatSupport from '@/views/auto-messages/integrations-that-support.vue';
Vue.component('m-integrations-that-support', MIntegrationsThatSupport);

import MFAQ from '@/components/input/faq.vue';
Vue.component('m-faq', MFAQ);

import SearchFilters from '@/components/input/query/search-filters.vue';
Vue.component('m-search-filters', SearchFilters);

import SearchFilterEditDialog from '@/components/input/query/search-filter-edit-dialog.vue';
Vue.component('m-search-filter-edit-dialog', SearchFilterEditDialog);

import MEditMultiSelect from '@/components/input/m-edit-multi-select.vue';
Vue.component('m-edit-multi-select', MEditMultiSelect);

import MEditMultiSelectDialog from '@/components/input/m-edit-multi-select-dialog.vue';
Vue.component('m-edit-multi-select-dialog', MEditMultiSelectDialog);

import MTextValidateField from '@/components/input/m-text-validate-field.vue';
Vue.component('m-text-validate-field', MTextValidateField);

import MDeveloperAppCredentialsEditDialog from '@/views/app-store/developer-app-credentials-edit-dialog.vue';
Vue.component('m-developer-app-credentials-edit-dialog', MDeveloperAppCredentialsEditDialog);

import MMessageRedirectPackageDialog from '@/components/sms/shipping/m-message-redirect-package-dialog.vue';
Vue.component('m-message-redirect-package-dialog', MMessageRedirectPackageDialog);

import MTimelineCard from '@/views/timeline/m-timeline-card.vue';
Vue.component('m-timeline-card', MTimelineCard);

import MTimelineEvent from '@/views/timeline/m-timeline-event.vue';
Vue.component('m-timeline-event', MTimelineEvent);

import MConversationChips from '@/components/sms/conversation-chips.vue';
Vue.component('m-conversation-chips', MConversationChips);

import MDialogConversationChipRecentShipments from '@/components/sms/shipping/m-dialog-conversation-chip-recent-shipments.vue';
Vue.component('m-dialog-conversation-chip-recent-shipments', MDialogConversationChipRecentShipments);

import MActionChip from '@/components/input/m-action-chip.vue';
Vue.component('m-action-chip', MActionChip);

import MActionChips from '@/components/input/m-action-chips.vue';
Vue.component('m-action-chips', MActionChips);

import MModelR1Faq from '@/views/model/model-r1-faq.vue';
Vue.component('m-model-r1-faq', MModelR1Faq);

import MModelR1LayerEditor from '@/views/model/model-r1-layer-edit.vue';
Vue.component('m-model-r1-layer-editor', MModelR1LayerEditor);

import MModelR1LayerInference from '@/views/model/model-r1-layer-inference.vue';
Vue.component('m-model-r1-layer-inference', MModelR1LayerInference);

import MModelR1OptimizeRecipientsDialog from '@/views/model/model-r1-optimize-recipients-dialog.vue';
Vue.component('m-model-r1-optimize-recipients-dialog', MModelR1OptimizeRecipientsDialog);

import MBulkMessageAddRecipientsYetToCustomizeClubDialog from '@/views/bulk/bulk-message-add-recipients-yet-to-customize-club-dialog.vue';
Vue.component('m-bulk-message-add-recipients-yet-to-customize-club-dialog', MBulkMessageAddRecipientsYetToCustomizeClubDialog);

import MNewMenuChip from '@/components/global/m-menu-chip.vue';
Vue.component('m-menu-chip', MNewMenuChip);

import MModelR1ContentFeedbackDialog from '@/views/model/model-r1-suggestions-to-improve-message-content-dialog.vue';
Vue.component('m-model-r1-suggestions-to-improve-message-content-dialog', MModelR1ContentFeedbackDialog)

import MEditCSSProperty from '@/components/input/m-edit-css-property.vue';
Vue.component('m-edit-css-property', MEditCSSProperty);

import MEditCSSPropertyDialog from '@/components/input/m-edit-css-property-dialog.vue';
Vue.component('m-edit-css-property-dialog', MEditCSSPropertyDialog);

import MEditCSSPropertyCtrl from '@/components/input/m-edit-css-property-ctrl.vue';
Vue.component('m-edit-css-property-ctrl', MEditCSSPropertyCtrl);

import MEditStyledText from '@/components/input/m-edit-styled-text.vue';
Vue.component('m-edit-styled-text', MEditStyledText);

import MSettingsOrganizationFontEditDialog from '@/views/settings/organizations/settings-organization-fonts-edit-dialog.vue';
Vue.component('m-settings-organization-font-edit-dialog', MSettingsOrganizationFontEditDialog);

import MEditCSS from '@/components/input/m-edit-css.vue';
Vue.component('m-edit-css', MEditCSS);

import MEditLightboxUrl from '@/views/lightbox/m-edit-lightbox-url.vue';
Vue.component('m-edit-lightbox-url', MEditLightboxUrl);

import MIconButton from '@/components/input/m-icon-btn.vue';
Vue.component('m-icon-btn', MIconButton);

import CompatibleIntegrationsHint from '@/components/input/compatible-integrations-hint.vue';
Vue.component('m-compatible-integrations-hint', CompatibleIntegrationsHint);

import DoubleOptInExplanation from '@/components/consent/double-opt-in-explanation.vue';
Vue.component('m-double-opt-in-explanation', DoubleOptInExplanation);

import AutoMessageSetSendModeDialog from '@/views/auto-messages/auto-message-set-send-mode-dialog.vue';
Vue.component('m-auto-message-set-send-mode-dialog', AutoMessageSetSendModeDialog);

import RcBaseInput from "@/components/shared/inputs/rc-base-input.vue";
Vue.component('rc-base-input', RcBaseInput);

import RcLink from '@/components/shared/hyperlinks/rc-link.vue';
Vue.component('rc-link', RcLink);

import RcAlertLocalStorage from '@/components/shared/alerts/rc-alert-local-storage.vue';
Vue.component('rc-alert-local-storage', RcAlertLocalStorage);

import LinkBack from '@/components/shared/hyperlinks/link-back.vue';
Vue.component('link-back', LinkBack);

import AutoMessageReviewDialog from '@/views/auto-messages/auto-message-review-dialog.vue';
Vue.component('m-auto-message-review-dialog', AutoMessageReviewDialog);

import "@/assets/global.css"
import RedChirp from "./js/RedChirp";

Vue.config.productionTip = false;

Vue.prototype.$event_bus = new Vue();
Vue.prototype.$rc = new RedChirp(Vue.prototype.$event_bus);

import { STORAGE_KEY_ALERT_VISIBILITY } from '@/js/HashVersion.js';
if (sessionStorage.getItem(STORAGE_KEY_ALERT_VISIBILITY) === 'true') {
  sessionStorage.removeItem(STORAGE_KEY_ALERT_VISIBILITY);
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
